import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAvailableProductsForShopQueryVariables = Types.Exact<{
  organization_id: Types.Scalars['uuid']['input'];
  property_id: Types.Scalars['uuid']['input'];
}>;


export type GetAvailableProductsForShopQuery = { __typename?: 'query_root', products: Array<{ __typename?: 'products', id: any, name: string, description: string, sku?: string | null, make: string, model: string, retail_price?: any | null, extended_price?: any | null, product_notes?: string | null, created_at?: any | null, updated_at?: any | null, workspace_id?: any | null, organization_id?: any | null, photo_link?: string | null, partition_id?: string | null, product_category: { __typename?: 'product_categories', label: string } }> };


export const GetAvailableProductsForShopDocument = gql`
    query getAvailableProductsForShop($organization_id: uuid!, $property_id: uuid!) {
  products(
    where: {organization_id: {_eq: $organization_id}, _not: {shop_products: {property_id: {_eq: $property_id}}}}
  ) {
    id
    name
    description
    sku
    product_category {
      label
    }
    make
    model
    retail_price
    extended_price
    product_notes
    created_at
    updated_at
    workspace_id
    organization_id
    photo_link
    partition_id
  }
}
    `;

/**
 * __useGetAvailableProductsForShopQuery__
 *
 * To run a query within a React component, call `useGetAvailableProductsForShopQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableProductsForShopQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableProductsForShopQuery({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *      property_id: // value for 'property_id'
 *   },
 * });
 */
export function useGetAvailableProductsForShopQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableProductsForShopQuery, GetAvailableProductsForShopQueryVariables> & ({ variables: GetAvailableProductsForShopQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableProductsForShopQuery, GetAvailableProductsForShopQueryVariables>(GetAvailableProductsForShopDocument, options);
      }
export function useGetAvailableProductsForShopLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableProductsForShopQuery, GetAvailableProductsForShopQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableProductsForShopQuery, GetAvailableProductsForShopQueryVariables>(GetAvailableProductsForShopDocument, options);
        }
export function useGetAvailableProductsForShopSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableProductsForShopQuery, GetAvailableProductsForShopQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableProductsForShopQuery, GetAvailableProductsForShopQueryVariables>(GetAvailableProductsForShopDocument, options);
        }
export type GetAvailableProductsForShopQueryHookResult = ReturnType<typeof useGetAvailableProductsForShopQuery>;
export type GetAvailableProductsForShopLazyQueryHookResult = ReturnType<typeof useGetAvailableProductsForShopLazyQuery>;
export type GetAvailableProductsForShopSuspenseQueryHookResult = ReturnType<typeof useGetAvailableProductsForShopSuspenseQuery>;
export type GetAvailableProductsForShopQueryResult = Apollo.QueryResult<GetAvailableProductsForShopQuery, GetAvailableProductsForShopQueryVariables>;